// Convert consumer configuration to match format returned from the API endpoint.
export const convertConsumerConfig = configPayload => {
  if (configPayload.uis) {
    let { uis, ...updatedConfig } = configPayload;
    updatedConfig['consumer'] = uis.consumer;
    return updatedConfig;
  }
  return configPayload;
};
